const About = {
    about: {
        title: "Come along my journey with me !",
        description: "Computering engineering and computer science student at Boston University urrently working in the BU Robotics Lab. Passionate about the combination of robotics, AI, and all things tech !",
        experience: [
            {
                title: "ROS2",
                company: "Robotics Lab",
                date: "2019 - Present",
                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            },
            {
                title: "Motion Capture",
                company: "Robotics Lab",
                date: "2017 - 2019",
                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            },
            {
                title: "Coding -- add later as learned",
                company: "Robotics Lab",
                date: "2014 - 2017",
                description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
            },
        ],
        education: [
            {
                degree: "Week 1",
                program: "Orientation",
                school: "BU Robotics Lab",
                date: "October 20, 2025 - October 24, 2025",
                about: "to be contoinued.."
            },
            {
                degree: "Week 2",
                program: "familiarize",
                school: "BU Robotics Lab",
                date: "October 27, 2025 - October 31, 2025",
                about: "to be contoinued..."
            },
            {
                degree: "Week 3",
                program: "familiarize",
                school: "BU Robotics Lab",
                date: "October 27, 2025 - October 31, 2025",
                about: "to be contoinued..."
            },
            {
                degree: "Week 4",
                program: "familiarize",
                school: "BU Robotics Lab",
                date: "October 27, 2025 - October 31, 2025",
                about: "to be contoinued..."
            },
            {
                degree: "Week 5",
                program: "familiarize",
                school: "BU Robotics Lab",
                date: "October 27, 2025 - October 31, 2025",
                about: "to be contoinued..."
            }
        ]
    },
    contact: {
        title: "Get in touch",
        description: "Always open to new opportunities !",
        email: "meltran@bu.edu",
        formspree: ""
    },
    home: {
        name: "Melinda Tran",
        title: "BU Robotics Lab Notebook",
        description: "Weekly updates to document progress and learnings in the BU Robotics Lab",
    },
    social: {
        linkedin: "melintran"
    },

};

export default About;
